import { render, staticRenderFns } from "./PurpleNextIcon.vue?vue&type=template&id=6d86d35c"
import script from "./PurpleNextIcon.vue?vue&type=script&lang=js"
export * from "./PurpleNextIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports